import { LegacyHeader, type HeaderProps as LegacyHeaderProps } from './legacy';
import { Header as NewHeader } from './Header';
import type { HeaderData } from './types';

// TODO: Remove this file as soon as the new header is fully rolled out

export function isLegacyHeaderData(data: HeaderData): data is LegacyHeaderProps {
  return (data as LegacyHeaderProps)?.mainMenuItems !== undefined;
}

// removes data that leads to the delivery location banner being displayed
export function disableDeliveryLocationBanner(header: HeaderData): HeaderData {
  if (isLegacyHeaderData(header)) {
    return {
      ...header,
      deliveryLocationBannerContent: null,
    };
  }
  return {
    ...header,
  };
}

// wrapper component to render the "new" or legacy header
export const Header = ({ header }: { header: HeaderData }) =>
  /* eslint-disable-next-line react/jsx-props-no-spreading */
  isLegacyHeaderData(header) ? <LegacyHeader {...header} /> : <NewHeader {...header} />;
